/**
 * Essential Upsell and Eure Lieblinge: one theme list for the format.
 * The trigger sits over the pill so the app click never opens the system menu.
 * The list is a single column, as wide as the pill.
 * It is on document.body, or inside the cart dialog, so nothing clips it.
 */
(function () {
  'use strict';

  if (window.__mkUpsellSelect) return;
  window.__mkUpsellSelect = true;

  var openWrap = null;

  function showFirstCardOnly() {
    document.querySelectorAll(':is(essential-upsell-cross-sell-app-block, essential-upsell-app-embed) [data-essential-upsell-element="products"]').forEach(function (row) {
      var cards = row.querySelectorAll('[data-essential-upsell-element="product"]');
      cards.forEach(function (card, index) {
        if (index === 0) return;
        var hide = card;
        while (
          hide.parentElement &&
          hide.parentElement !== row &&
          hide.parentElement.querySelectorAll('[data-essential-upsell-element="product"]').length === 1
        ) {
          hide = hide.parentElement;
        }
        hide.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function listOf(wrap) {
    return wrap && document.getElementById(wrap.dataset.mkListId);
  }

  function closeWrap(wrap) {
    if (!wrap) return;
    var list = listOf(wrap);
    var trigger = wrap.querySelector('.mk-upsell-select__trigger');
    if (list) list.hidden = true;
    wrap.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (openWrap === wrap) openWrap = null;
  }

  function place(list, box) {
    var rect = box.getBoundingClientRect();
    var dialog = list.closest('dialog');
    var originTop = 0;
    var originLeft = 0;
    var limit = window.innerHeight;
    if (dialog) {
      var frame = dialog.getBoundingClientRect();
      originTop = frame.top;
      originLeft = frame.left;
      limit = frame.bottom;
    }
    var width = rect.width;
    var card = box.closest && box.closest('.mk-fav__card');
    var add = card && card.querySelector('.mk-fav__add');
    if (add) {
      var addRect = add.getBoundingClientRect();
      var room = addRect.left - rect.left - 8;
      if (addRect.left > rect.left + 8 && room >= 48) width = Math.min(width, room);
    }
    var top = rect.bottom + 6 - originTop;
    list.style.minWidth = '0';
    list.style.maxWidth = width + 'px';
    list.style.left = (rect.left - originLeft) + 'px';
    list.style.width = width + 'px';
    list.style.top = top + 'px';
    var height = list.offsetHeight;
    if (rect.bottom + 6 + height > limit) {
      list.style.top = Math.max(8, rect.top - originTop - height - 6) + 'px';
    }
  }

  function syncValue(select, valueEl) {
    var chosen = select.options[select.selectedIndex];
    if (valueEl && chosen) valueEl.textContent = chosen.text;
  }

  function bind(select) {
    var wrap = select.closest('[data-essential-upsell-element="variant-select"]');
    var box = wrap && wrap.querySelector('[data-essential-upsell-element="container"]');
    if (select.dataset.mkBound === 'true') {
      if (wrap && wrap.querySelector('.mk-upsell-select__trigger') && listOf(wrap)) return;
      select.dataset.mkBound = '';
      if (wrap && wrap.dataset.mkListId) {
        var stale = document.getElementById(wrap.dataset.mkListId);
        if (stale) stale.remove();
        delete wrap.dataset.mkListId;
      }
    }
    if (!wrap || !box || select.options.length < 2) return;
    if (box.getBoundingClientRect().width < 1) return;
    select.dataset.mkBound = 'true';
    wrap.classList.add('is-custom');

    var valueEl = wrap.querySelector('[data-essential-upsell-element="value"]');
    var list = document.createElement('div');
    list.className = 'mk-upsell-select__list';
    list.hidden = true;
    list.setAttribute('role', 'listbox');
    var listId = 'mk-upsell-list-' + Math.random().toString(36).slice(2, 8);
    list.id = listId;
    wrap.dataset.mkListId = listId;
    (select.closest('dialog') || document.body).appendChild(list);

    var product = wrap.closest('[data-essential-upsell-element="product"]');
    var titleEl = product && product.querySelector('[data-essential-upsell-element="title"]');
    var productName = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var label = productName ? 'Format für ' + productName : 'Format wählen';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mk-upsell-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', listId);
    trigger.setAttribute('aria-label', label);
    box.appendChild(trigger);

    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    function paint() {
      list.replaceChildren();
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.disabled) return;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'mk-upsell-select__option';
        item.setAttribute('role', 'option');
        item.textContent = opt.text;
        item.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
        item.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (select.value !== opt.value) {
            select.value = opt.value;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          syncValue(select, valueEl);
          closeWrap(wrap);
        });
        list.appendChild(item);
      });
      syncValue(select, valueEl);
    }

    function open() {
      if (openWrap && openWrap !== wrap) closeWrap(openWrap);
      paint();
      list.hidden = false;
      place(list, box);
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      openWrap = wrap;
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (list.hidden) open();
      else closeWrap(wrap);
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
        var current = list.querySelector('[aria-selected="true"]') || list.querySelector('button');
        if (current) current.focus({ preventScroll: true });
      }
    });

    list.addEventListener('keydown', function (event) {
      var items = Array.prototype.slice.call(list.querySelectorAll('button'));
      var index = items.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault();
        closeWrap(wrap);
        trigger.focus({ preventScroll: true });
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        var next = event.key === 'ArrowDown' ? index + 1 : index - 1;
        if (next < 0) next = items.length - 1;
        if (next >= items.length) next = 0;
        if (items[next]) items[next].focus({ preventScroll: true });
      }
    });

    select.addEventListener('change', function () {
      syncValue(select, valueEl);
    });

    paint();
  }

  function bindFavorite(select) {
    var wrap = select.closest('.mk-fav__option');
    if (!wrap) return;
    if (select.dataset.mkBound === 'true') {
      if (wrap.querySelector('.mk-fav__trigger') && listOf(wrap)) return;
      select.dataset.mkBound = '';
      if (wrap.dataset.mkListId) {
        var stale = document.getElementById(wrap.dataset.mkListId);
        if (stale) stale.remove();
        delete wrap.dataset.mkListId;
      }
    }
    if (select.options.length < 2) return;
    select.dataset.mkBound = 'true';
    wrap.classList.add('is-custom');

    var list = document.createElement('div');
    list.className = 'mk-upsell-select__list mk-fav__list';
    list.hidden = true;
    list.setAttribute('role', 'listbox');
    var listId = 'mk-fav-list-' + Math.random().toString(36).slice(2, 8);
    list.id = listId;
    wrap.dataset.mkListId = listId;
    (select.closest('dialog') || document.body).appendChild(list);

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mk-upsell-select__trigger mk-fav__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', listId);
    trigger.setAttribute('aria-label', select.getAttribute('aria-label') || 'Format');
    wrap.appendChild(trigger);
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    function paint() {
      var chosen = select.options[select.selectedIndex];
      trigger.textContent = chosen ? chosen.text : '';
      list.replaceChildren();
      Array.prototype.forEach.call(select.options, function (opt) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'mk-upsell-select__option';
        item.setAttribute('role', 'option');
        item.textContent = opt.text;
        item.disabled = opt.disabled;
        item.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
        if (opt.disabled) item.setAttribute('aria-disabled', 'true');
        item.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (opt.disabled) return;
          if (select.value !== opt.value) {
            select.value = opt.value;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          closeWrap(wrap);
          paint();
        });
        list.appendChild(item);
      });
    }

    function open() {
      if (openWrap && openWrap !== wrap) closeWrap(openWrap);
      paint();
      list.hidden = false;
      place(list, trigger);
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      openWrap = wrap;
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (list.hidden) open();
      else closeWrap(wrap);
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
        var current = list.querySelector('[aria-selected="true"]') || list.querySelector('button:not(:disabled)');
        if (current) current.focus({ preventScroll: true });
      }
    });

    list.addEventListener('keydown', function (event) {
      var items = Array.prototype.slice.call(list.querySelectorAll('button:not(:disabled)'));
      var index = items.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault();
        closeWrap(wrap);
        trigger.focus({ preventScroll: true });
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        var next = event.key === 'ArrowDown' ? index + 1 : index - 1;
        if (next < 0) next = items.length - 1;
        if (next >= items.length) next = 0;
        if (items[next]) items[next].focus({ preventScroll: true });
      }
    });

    select.addEventListener('change', paint);
    paint();
  }

  function boot() {
    showFirstCardOnly();
    document.querySelectorAll(':is(essential-upsell-cross-sell-app-block, essential-upsell-app-embed) select').forEach(bind);
    document.querySelectorAll('select.mk-fav__select').forEach(bindFavorite);
  }

  document.addEventListener('click', function (event) {
    if (!openWrap) return;
    var list = listOf(openWrap);
    if (event.target.closest && (event.target.closest('.mk-upsell-select__trigger') || (list && list.contains(event.target)))) return;
    closeWrap(openWrap);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openWrap) closeWrap(openWrap);
  });

  // The mobile announcement marquee scrolls every frame. Only a scroller
  // that actually contains the trigger should dismiss the list.
  document.addEventListener('scroll', function (event) {
    if (!openWrap) return;
    var list = listOf(openWrap);
    var scroller = event.target;
    if (list && (scroller === list || (scroller && list.contains && list.contains(scroller)))) return;
    var movesTrigger = scroller === document || scroller === document.documentElement || scroller === document.body || (scroller && scroller.contains && scroller.contains(openWrap));
    if (movesTrigger) closeWrap(openWrap);
  }, true);

  boot();
  var observer = new MutationObserver(function () {
    boot();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
